import { useApolloClient } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { useGlobalLoading } from "../../../shared/hooks/useGlobalLoading";
import Button from "@mostrans/web-components/components/base/Button";
import { parseToExcel } from "@mostrans/web-components/helpers/excelHelpers";
import { Icon } from "@mui/material";
import { GetOpportunityByID } from "../../../GQL/queries";

export const ButtonExportCandidate = (props) => {
  const client = useApolloClient();
  const [loading, setLoading] = useGlobalLoading();
  const [opportunity, setOpportunity] = useState([]);

  const candidate = props.dataCandidates;

  useEffect(() => {
    if (props.id) {
      async function fetchCandidate() {
        await fetchOpportunityByID();
      }
      fetchCandidate();
    }
  }, [props.id]);

  const fetchOpportunityByID = async () => {
    await GetOpportunityByID(client, parseInt(props.id)).then((data) =>
      setOpportunity(data)
    );
  };

  const handleExport = async () => {
    if (loading) return;
    setLoading(true);
    parseToExcel(`Kandidat ${opportunity?.title}`, [
      {
        // Posisi, Nama, Universitas, Pendidikan terakhir, Jurusan, dan Sumber Informasi lowongan kerja.
        data: candidate?.map((candidates) => ({
          Posisi: opportunity?.title,
          Nama: candidates?.full_name,
          Universitas: candidates?.Educations
            ? candidates?.Educations?.map((edu) => edu?.school_name).join(", ")
            : "-",
          "Pendidikan terakhir": candidates?.Educations
            ? candidates?.Educations?.map((edu) => edu?.degree).join(", ")
            : "-",
          Jurusan: candidates?.Educations
            ? candidates?.Educations?.map((edu) => edu?.major).join(", ")
            : "-",
          "Sumber Informasi": candidates?.source_info
            ? candidates?.source_info
            : "-",
        })),
        sheetName: "Daftar Kandidat",
        inputType: "json",
      },
    ]);
    setLoading(false);
  };

  return (
    <Button
      startIcon={<Icon>download_file</Icon>}
      onClick={handleExport}
      variant="outlined"
      color="primary"
    >
      Export Candidate
    </Button>
  );
};
